<template>
  <div class="cart__item">
    <div class="cart__item-content">
      <div class="quick-cart__image">
        <a :href="item.url">
          <img
            :src="getItemImage(item.image)"
            :alt="`${item.product_title} image`"
          >
        </a>
        <div class="quick-cart__item-bottom">
          <QuantityInput
            v-model="quantity"
            class="line-item__quantity"
            :min="0"
            :step="1"
            @input="onQuantityUpdate(quantity)"
          />
        </div>
      </div>
      <div class="quick-cart__product-details justify-between">
        <div class="quick-cart__product-details-wrapper">
          <p class="cart__item-title">
            <a
              class="color-fv-red"
              :href="item.url"
            >{{ item.product_title }}</a>
          </p>
          <span class="quick-cart__product-price d-block">
            <span class="quick-cart__product-price-value h6 d-block">
              {{ item.price | money }}
              <span v-if="item.quantity > 1"> x {{ item.quantity }}</span>
            </span>
            <ul
              v-if="getDiscounts(item).length > 0"
              class="quick-cart__item-discounts"
            >
              <li
                v-for="(discount, index) in getDiscounts(item)"
                :key="index"
                class="h6"
              >
                {{ discount.discount_application.title }} (-{{ discount.amount | money }})
              </li>
            </ul>
          </span>
          <ul
            v-if="!item.product_has_only_default_variant"
            class="quick-cart__product-options"
          >
            <li v-if="getColorName(item)">
              <span>{{ colorOptionText }}: </span>
              <span>{{ getColorName(item) }}</span>
            </li>
            <li
              v-for="(option, index) in item.options_with_values"
              :key="index"
            >
              <span>{{ option.name }}: </span>
              <span>{{ option.value }}</span>
            </li>
          </ul>
          <span v-show="this.finalSale" class="mini-cart-final-sale-badge">FINAL SALE</span>
          <div class="quick-cart__remove-items-underline">
            <a
            @click="removeItem">
              <span class="quick-cart__remove-items">Remove</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { getSizedImageUrl } from 'scripts/helpers/images';
  import { getColorName } from 'scripts/helpers/product';
  import QuantityInput from 'scripts/components/forms/QuantityInput.vue';

  export default {
    components: {
      QuantityInput
    },

    props: {
      item: {
        type: Object,
        required: true,
      },

    },

    data() {
      return {
        quantity: 1,
        updating: false,
        finalSale: false
      };
    },

    computed: {
      colorOptionText() {
        return window.theme.strings.products.product.color;
      },
    },

    watch: {
      async item() {
        this.quantity = this.item.quantity;
        this.finalSale = await this.fetchData(this.item.handle.split('?')[0])
      }
    },

    async mounted() {
      this.quantity = this.item.quantity;
      this.finalSale = await this.fetchData(this.item.handle.split('?')[0])
    },
    
    methods: {
      ...mapActions({
        updateProduct: 'cart/updateItem',
      }),
      
      removeItem() {
        this.updating = true;
        this.$store
          .dispatch("cart/removeItem", this.item.key)
          .catch(error =>
            this.$store.dispatch("toast/send", { text: error, type: "error" })
          )
          // eslint-disable-next-line no-return-assign
          .then(() => (this.updating = false));
      },

      getColorName(item) {
        if (!item.properties) {
          return null;
        }

        const colorFromItemProperty = item.properties.color;

        if (!colorFromItemProperty || colorFromItemProperty.includes('no-image')) {
          return null;
        }

        return getColorName(colorFromItemProperty);
      },

      getDiscounts(item) {
        return item.line_level_discount_allocations;
      },

      getItemImage(url) {
        return getSizedImageUrl(url, '160x');
      },

      async onQuantityUpdate(quantity) {
        await this.updateProduct({
          key: this.item.key,
          quantity
        });
      },
      async fetchData(handle) {
          return fetch(`https://francesvalentine.com/products/${handle}?view=final-sale`)
          .then(response => {
            if (!response.ok) {
              throw Error('Error fetching product info');
            }
            return response.json()
          })
          .then(response => {
            return response.final_sale
          })
      }
    },
  };
</script>

<style lang="scss" scoped>
</style>
